import { Injectable } from "@angular/core"
import { AngularFirestoreCollection } from "@angular/fire/firestore"
import { TestRun, UserDefaultColumns } from "@tr/models"
import { DataService } from "./data.service"
import { FirebaseService } from "./firebase.service"
import { UserDefaultsBaseService } from "./user-defaults-base.service"

@Injectable({
  providedIn: "root",
})
export class TestRunsService extends UserDefaultsBaseService<UserDefaultColumns, TestRun> {
  public userDefaultsDocName = "TestRuns"
  public initialized = false
  public getId = (item: TestRun) => item._id

  constructor(fb: FirebaseService, dataService: DataService) {
    super(fb, dataService)
  }

  public getCollection(company: string, project: string): AngularFirestoreCollection {
    return this.firebaseService
      .collection("companies")
      .doc(company)
      .collection("projects")
      .doc(project)
      .collection("Test Runs")
  }

  public matchesRun(run: TestRun, runId: string): boolean {
    return this.isDocId(runId) ? run._id === runId : run.runId === +runId
  }

  public isDocId(runId: string): boolean {
    return !Number.isInteger(+runId)
  }

  public async getData(runId: string, company, project): Promise<TestRun[]> {
    const collectionSnapshot = await this.getCollection(company, project)
      .ref.where("runId", "==", +runId)
      .get()

    this.data = collectionSnapshot.empty
      ? []
      : collectionSnapshot.docs.map<TestRun>(testRunSnapshot => {
        if (!testRunSnapshot.exists) {
          return null
        }

        const testRun = testRunSnapshot.data() as TestRun
        testRun._id = testRunSnapshot.id
        this.dataMap[testRunSnapshot.id] = testRun
        return testRun
      }).filter(item => !!item)

    this.initialized = true
    return this.data
  }

  public async getDataItem(id: string, company: string, project: string, refresh = false): Promise<TestRun> {
    if (refresh || !this.dataMap[id]) {
      const itemSnapshot = await this.getCollection(company, project)
        .doc(id)
        .ref.get()

      if (!itemSnapshot.exists) {
        return null
      }

      const item = itemSnapshot.data() as TestRun
      item._id = itemSnapshot.id
      this.dataMap[id] = item
    }

    return this.dataMap[id]
  }

  public async getRunId(company: string, project: string, runId: string | number): Promise<string> {
    const doc = await this.getCollection(company, project)
      .doc(`${runId}`)
      .ref.get()
    return doc.exists
      ? doc.data().runId
      : ""
  }

  public async update(
    company: string,
    project: string,
    testRunId: string,
    testRunToUpdate: any,
  ): Promise<void> {
    return this.getCollection(company, project)
      .doc(testRunId)
      .update(testRunToUpdate)
  }
}
